<template>
    <div class="sg-custom-check-and-radio sg-btn-toggle-icon" :class="{ 'sg-disabled': disabled }">
        <label :class="labelClass">
            <input v-model="state" type="checkbox" :disabled="disabled" />
            <div class="sg-btn" :class="[customClass, { 'sg-btn-icon': iconClass }]">
                <span class="sg-btn-toggle-icon-icon" :class="iconClass" />
                <span class="sg-btn-toggle-icon-label">
                    <slot />
                </span>
            </div>
        </label>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Component, Prop } from 'vue-property-decorator';
import ToggleMixin from '@/vue/components/shared/toggles/ToggleMixin';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-toggle-button')
export default class VrmToggleButton extends ToggleMixin {
    @Prop({ type: String })
    customClass;
    @Prop({ type: String })
    iconClass;
    @Prop({ type: String })
    labelClass;
}
</script>
